export interface IEncryptionObjectList {
    /**
     * Název zobrazeného atributu
     */
    count: number;
    list: IEncryptionObjectEntry[];
}

export class IEncryptionObjectList {
    public static [Symbol.hasInstance](instance: any): boolean {
        return instance != null &&
            Reflect.has(instance, "type") && Reflect.get(instance, "type") === "TescoSW.Global.Cryptography.EncryptionObjectList";
    }
}

export interface IEncryptionObjectEntry {
    instanceID: string;
    id: string;
    objectName: string;
    objectIdentifier: string;
    encryptedKey: string;
    encryptionInfo: string;
    encryptedKeyBytes: Uint8Array;
    key: string;
    keyBytes: Uint8Array;
}

export class IEncryptionObjectEntry {
    public static [Symbol.hasInstance](instance: any): boolean {
        return instance != null &&
            Reflect.has(instance, "instanceID") &&
            Reflect.has(instance, "id") &&
            Reflect.has(instance, "objectName") &&
            Reflect.has(instance, "objectIdentifier") &&
            Reflect.has(instance, "encryptedKey") &&
            Reflect.has(instance, "encryptionInfo") &&
            Reflect.has(instance, "encryptedKeyBytes") &&
            Reflect.has(instance, "key") &&
            Reflect.has(instance, "keyBytes");
    }
}
